{
    "OptionsMenuTitle": "Affiche les options disponibles pour ce sous-rapport de tableau de bord.",
    "DashboardDraggableTitle": "Faites-le glisser sur un autre rapport de ce tableau de bord pour échanger les places.",
    "OptionsMenuRemove": "Supprimer le rapport",
    "OptionsMenuAdd": "Créer un nouveau rapport",
    "OptionsMenuModify": "Modifier le rapport",
    "OptionsMenuChange": "Rapport sur les commutateurs",
    "OptionsMenuChoose": "Choisir le rapport",
    "OptionMenuUpdateReportError": "Il y a eu une erreur en essayant de mettre à jour le rapport du tableau de bord.",
    "OptionMenuRemovePermDelete": "Supprimer définitivement ce rapport",
    "NAME": "DashboardOptions"
}